/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getFootprintReport = (params) => makeApiCall(`/cnc/footprints/report`, 'GET', params);

export const getFootprintReportExport = (params) =>
  makeApiCall(`/cnc/footprints/export`, 'GET', params);
